import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { catchError, map, takeUntil } from "rxjs/operators";
import { LoaderService } from "src/app/_metronic/partials/content/loader/loader.service";
import { CoreHelperService } from "./core-helper.service";

@Injectable()
export class IntercepterService implements HttpInterceptor {
    error: any;
    private pendingHTTPRequests$ = new Subject<void>();

    constructor(
        private router: Router,
        public coreHelperService: CoreHelperService,
        private loaderService: LoaderService) {
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.loaderService.show()
        request = request.clone({
            setHeaders: {
                Authorization: `${sessionStorage.getItem("jwtToken")}`,
                academicyearid: `${sessionStorage.getItem("academicyearid")}`,
                'Access-Control-Expose-Headers': '*',
                BranchId: `${sessionStorage.getItem("BranchId")}`,
                InstituteId: `${sessionStorage.getItem("InstituteId")}`,
            }
        });
        return next.handle(request)
            .pipe(
                map(event => {
                    if (event instanceof HttpResponse) {
                        this.loaderService.hide()
                        if (!this.coreHelperService.isNullOrUndefined(event.headers.get('Version-Number'))
                            && this.coreHelperService.isNullOrUndefined(sessionStorage.getItem('Version-Number'))) {
                            sessionStorage.setItem('Version-Number', (event.headers.get('Version-Number')))
                        }
                        if (!this.coreHelperService.isNullOrUndefined(event.headers.get('Version-Number')) &&
                            !this.coreHelperService.isNullOrUndefined(sessionStorage.getItem('Version-Number')) && event.headers.get('Version-Number') != sessionStorage.getItem('Version-Number')) {
                            sessionStorage.setItem('Version-Number', (event.headers.get('Version-Number')))
                           sessionStorage.clear();
                            this.router.navigate(['/auth/login']);
                        }
                    }
                    return event;
                }),
                catchError((error: HttpErrorResponse) => {
                    this.loaderService.hide()
                    this.showError(error);
                    throw error;
                }),
                takeUntil(this.onCancelPendingRequests())
            );
    }
    showError = (error) => {
        let errorToDisplay = error.error.data;
        let statusCode = error.status
        if (!this.coreHelperService.isNullOrUndefined(errorToDisplay)) {
            if (statusCode == 500) {
                this.coreHelperService.showSweetAlert('<h4>Internal Server Error</h4>', 'error')
            }
            else if (statusCode == 403) {
                this.router.navigate(['/auth/login']);
                sessionStorage.clear()
            }
            else if (statusCode == 401) {
                this.router.navigate(['/error/unauthorized']);
            }
        }
        else {
            // swal.fire({
            //     title: 'Alert!',
            //     html: `<h4>You are offline ! Currently, the server is not reachable ! Please try again later</h4>`,
            // });
        }
    }

    public cancelPendingRequests() {
        this.pendingHTTPRequests$.next();
        this.loaderService.hide();
    }

    public onCancelPendingRequests() {
        return this.pendingHTTPRequests$.asObservable();
    }
}
